import { BaseEntity } from "@app/common";
import { prop, required } from "@messaia/cdk";

export class TariffFootnote extends BaseEntity {
    @prop()
    id: number;

    @prop()
    tariffId: number;

    @required()
    name: string;

    @prop()
    title: string;

    @required()
    body: string;

    @prop()
    enabled: boolean = true;
}